import React from "react"
import { Layout } from "antd"
import AppSidebar from "@components/layout/sidebar"
import AppHeader from "@components/layout/menu"
import { ISidebarItems } from "@/types/layout"
const { Content, Footer } = Layout

interface IProps {
  sidebarItems: ISidebarItems
  children: any
  onRemoveUserToken: any
  userName: string | null
  selectedSideBar: string
}

const AppLayout: React.FunctionComponent<IProps> = ({
  sidebarItems,
  children,
  onRemoveUserToken,
  userName,
  selectedSideBar,
}) => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <AppHeader onRemoveUserToken={onRemoveUserToken} userName={userName} />
      <Content style={{ marginTop: 100 }}>
        <Layout style={{ margin: "0 10px" }}>
          <AppSidebar
            sidebarItems={sidebarItems}
            selectedItem={selectedSideBar}
          />
          <Content
            style={{
              marginLeft: 10,
              padding: "20px",
              height: "calc(100vh - 100px)",
              backgroundColor: "white",
              overflow: "scroll",
            }}
          >
            {children}
          </Content>
        </Layout>
      </Content>
      <Footer
        style={{
          textAlign: "center",
          height: 100,
          backgroundColor: "#f6f6f6",
          lineHeight: "0px",
        }}
      >
        ©Unimelb
      </Footer>
    </Layout>
  )
}

export default AppLayout
